import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-image-dropper',
  templateUrl: './page-image-dropper.component.html',
  styleUrls: ['./page-image-dropper.component.scss']
})
export class PageImageDropperComponent {

  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";


  constructor() { }

}
